const v11 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        videosTable: {
          ...state.options.tableViews.videosTable,
          "eYTV (Videos)": false,
          "e8min (Videos)": false,
          "ViewRate (Videos)": false,
          "Views (Videos)": false,
          "eYTV (Search)": false,
          "e8min (Search)": false,
          "ViewRate (Search)": false,
          "Views (Search)": false,
        },
        topScriptTopicsTable: {
          ...state.options.tableViews.topScriptTopicsTable,
          "eYTV (Videos)": false,
          "e8min (Videos)": false,
          "ViewRate (Videos)": false,
          "Views (Videos)": false,
          "eYTV (Search)": false,
          "e8min (Search)": false,
          "ViewRate (Search)": false,
        },
        topThumbTopicsTable: {
          ...state.options.tableViews.topThumbTopicsTable,
          "eYTV (Videos)": false,
          "e8min (Videos)": false,
          "ViewRate (Videos)": false,
          "Views (Videos)": false,
          "eYTV (Search)": false,
          "e8min (Search)": false,
          "ViewRate (Search)": false,
        },
        topTitleTopicsTable: {
          ...state.options.tableViews.topTitleTopicsTable,
          "eYTV (Videos)": false,
          "e8min (Videos)": false,
          "ViewRate (Videos)": false,
          "Views (Videos)": false,
          "eYTV (Search)": false,
          "e8min (Search)": false,
          "ViewRate (Search)": false,
        },
        topVideoTypesTable: {
          ...state.options.tableViews.topVideoTypesTable,
          "eYTV (Videos)": false,
          "e8min (Videos)": false,
          "ViewRate (Videos)": false,
          "Views (Videos)": false,
          "eYTV (Search)": false,
          "e8min (Search)": false,
          "ViewRate (Search)": false,
        },
      },
    },
  };
};

export default v11;
